
import React, { Component } from 'react';
import { connect } from 'react-redux';
//import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getMotivo, modifyMotivo, removeMotivo, addMotivo, updateMotivoDB } from '../../actions/motivo_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresMotivo extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getMotivo();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkCvMotivo = (motivo) => {
        if (this.props.motivo.find(c => (c.descr === motivo.descr) && (c.iKind === motivo.iKind) &&  (c.id !== motivo.id))) {
            this.messageDialog(`Ya existe una motivo con descripción ${motivo.descr}`);
            return false;
        } else if (!motivo.descr.trim()) {
            this.messageDialog('Por favor, introduzca una Descripción');
            return false;
        }

        else return true;
    };

    editMotivo = (motivo) => {

        this.props.openDialog('EditCvMotivo', {
            motivo: motivo,
            checkMotivo: this.checkCvMotivo,
            okHandler: (sf) => {
                this.props.setSaveState(true);
                this.props.modifyMotivo(sf);
            },

        }, uuidv4());
    };

    newMotivo = () => {
        this.props.openDialog('EditCvMotivo', {
            motivo: {},
            checkMotivo: this.checkCvMotivo,
            okHandler: (tp) => {
                this.props.setSaveState(true);
                this.props.addMotivo(tp);
            },

        }, uuidv4());
    };    

    handleDeleteRow = motivo => {
        this.props.setSaveState(true);
        this.props.removeMotivo(motivo);
    };

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                        <NeuriteGrid
                            id="m_r_m"
                            columns={[
                                { key: 'kindDescr', name: 'Tipo', tooltip: 'Tipo de motivo', editable: false, dragable: false, width: 150 },
                                { key: 'descr', name: 'Descripción', editable: false, dragable: false, width: 200 },
                            ]}
                            rows={this.props.motivo}
                            height={500}
                            buttonEdit={true}
                            buttonDelete={true}
                            buttonNew={true}
                            onNewRowClick={this.newMotivo}
                            onEditClick={this.editMotivo}
                            // onRowsUpdated={this.handleGridRowsUpdated}
                            onDeleteClick={this.handleDeleteRow}
                        />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.motivo.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateMotivoDB(this.props.motivo)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresMotivo.propTypes = {
    //state
    motivo: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getMotivo: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyMotivo: PropTypes.func.isRequired,
    removeMotivo: PropTypes.func.isRequired,
    addMotivo: PropTypes.func.isRequired,
    updateMotivoDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        motivo: state.motivo.motivos,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getMotivo,
        openDialog,
        hideDialog,
        modifyMotivo,
        removeMotivo,
        addMotivo,
        updateMotivoDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresMotivo));